import * as React from 'react';
import c from 'classnames';
import styles from './ItemKudos.css';
import { formatNumber } from '../../lib/helpers';

const kudosColor = numOfKudos => {
  const str = numOfKudos.toString();
  return str.includes('-') ? c(styles.kudos, styles.minus) : c(styles.kudos, styles.plus);
};

export const ItemKudos = ({ numOfKudos }) => <span className={kudosColor(numOfKudos)}>{formatNumber(numOfKudos)}</span>;